import { render, staticRenderFns } from "./PortalBaseButton.vue?vue&type=template&id=6f95588b&scoped=true&"
import script from "./PortalBaseButton.vue?vue&type=script&lang=js&"
export * from "./PortalBaseButton.vue?vue&type=script&lang=js&"
import style0 from "./PortalBaseButton.vue?vue&type=style&index=0&id=6f95588b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f95588b",
  null
  
)

export default component.exports